module.exports = __webpack_public_path__ + "static/img/goukuang.23078d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/digitalsoftware/goukuang.png
// module id = 4iAR
// module chunks = 1